import { ReactNode, useState } from "react";
import {
  PopoverContent,
  PopoverPortal,
  PopoverTrigger,
  Root
} from "@radix-ui/react-popover";
import clsx from "clsx";
import { IProject } from "screens/Campaigns/types";
import { Button } from "components/Button";

type TProps = {
  projects: IProject[];
  children: ReactNode;
  hasMore?: boolean;
  isLoading?: boolean;
  onProjectClick: (project: IProject) => void;
  onLoadMoreClick?: () => void;
};

export const ProjectsDropdown = ({
  children,
  projects,
  hasMore,
  isLoading = false,
  onLoadMoreClick,
  onProjectClick,
}: TProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Root open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverPortal>
        <PopoverContent asChild className="bg-[#111111] w-[406px] z-[10]">
          <div className="overflow-auto custom-scrollbar max-h-[300px] flex flex-col">
            {projects.map((project, index) => (
              <div
                className={clsx(
                  "capitalize p-2 flex gap-4 items-center hover:bg-[#FFFFFF1A] cursor-pointer hover:text-[#FFC93D]"
                )}
                key={index}
                onClick={() => {
                  onProjectClick(project);
                  setIsOpen(false);
                }}
              >
                {project.title}
              </div>
            ))}

            {hasMore && (
              <Button extraClass="mx-auto my-4" disabled={isLoading} onClick={onLoadMoreClick}>
                {isLoading ? "Loading..." : "Load more"}
              </Button>
            )}
          </div>
        </PopoverContent>
      </PopoverPortal>
    </Root>
  );
};
